function removeEntityPrefix(fieldId, entityName) {
  if (!fieldId || !entityName) return fieldId;
  const prefix = entityName + '__';

  if (fieldId.startsWith(prefix)) {
    return fieldId.slice(prefix.length);
  }
  return fieldId;
}

function baseNodeId(id = ''){
  return id.split('__')[0];
}

export function convertOldMappingsToNew(mappingArray, nodesById) {
  const groupKey = (m) => `${m.sourceParentId}|||${m.destinationParentId}`;
  const groups = {};
 
  
  mappingArray.forEach((m) => {
    const key = groupKey(m);
    console.log('key:::', groupKey(m));
    console.log('key of groups of mapping:', key);
    if (!groups[key]) {
      const srcNode = nodesById[baseNodeId(m.sourceParentId)];
      const dstNode = nodesById[baseNodeId(m.destinationParentId)];

      console.log('srcNode:::', srcNode);

      groups[key] = {
        sourceEntity: m.sourceParentId,
        destinationEntity: m.destinationParentId,
        mappings: [],
        'source-connection-config': srcNode?.config || null,
        'destination-connection-config': dstNode?.config || null,
      };
    }

    if (!m.sourceFieldId || !m.destinationFieldId) {
      console.warn('Missing field ID in mapping:', m);
    }

    console.log('m.sourcefieldId:', m.sourceFieldId?.split('__')[1]);
    console.log('m.sourceLabel:', m.sourceLabel);
    console.log('m.destinationFieldId:', m.destinationFieldId?.split('__')[1]);
    console.log('m.destinationLabel:', m.destinationLabel);
    console.log('m.functionChain:', m.functionChain);

    groups[key].mappings.push({
      sourceField: removeEntityPrefix(m.sourceFieldId, m.sourceParentId) ?? '',
      destinationField:
        removeEntityPrefix(m.destinationFieldId, m.destinationParentId) ?? '',
      functionChain: (m.functionChain || []).map((fn) => ({
        function: fn.functionName,
        functionDetails: fn.config || {},
      })),
      // function: m.functionChain?.length ? m.functionChain[0]?.functionName : null,
      // functionDetails: m.functionChain?.length
      //   ? m.functionChain[0]?.config || {}
      //   : {},
    });
  });

  return Object.values(groups);
}
